// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__bB2xC","reverse":"divider_reverse__N02rH","green":"divider_green__fPxbH","violet":"divider_violet__YulIk","mix":"divider_mix__5h949"};